import { Icon } from "@kaggle/material";
import * as React from "react";
import styled from "styled-components";
import { CELL_SPACING } from "../../../components/jupyter/NotebookStyle";
import { WithJupyterServices } from "../../../jupyter/types";
import NotebookCell from "../types/ipynb/NotebookCell";
import NotebookCellType from "../types/ipynb/NotebookCellType";
import { SpacerButton } from "./buttons/SpacerButton";

// TODO(b/258073481): styled-components doesn't seem to work in this file. :|
// Things look okay on prod at the time of this writing, though.

const SpacerControls = styled.div`
  display: flex;
  /* margin-top: 0.3em; */
  margin-left: ${CELL_SPACING.left};

  > *:not(:first-child) {
    margin-left: 1rem;
  }
`;

const Body = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  font-size: 0.8571rem;
  height: ${CELL_SPACING.vertical};
  justify-content: center;
  position: relative;
  user-select: none;
  z-index: 1;

  opacity: ${(props: { isHovering: boolean }) => (props.isHovering ? 0.5 : 0)};

  &:hover {
    opacity: 1;
  }
`;

interface Props extends WithJupyterServices {
  location: "above" | "below";
  onInsertCell?: (cell: NotebookCell, index: number) => void;
  index: number;
  isActive: boolean;
  isHovering: boolean;
}

/** Sits above and below cells. */
export const CellSpacer = React.memo((props: Props) => {
  const insertCell = async (cellType: NotebookCellType) => {
    const { index, location, onInsertCell } = props;
    const action =
      location === "above"
        ? props.services.notebookClient.insertCellAbove
        : props.services.notebookClient.insertCellBelow;
    const cell = await action(cellType, index);
    if (onInsertCell) {
      onInsertCell(
        cell as any as NotebookCell,
        location === "above" ? index : index + 1
      );
    }
  };

  const style = {
    marginLeft: 60,
    marginTop: 5,
    opacity: props.isActive ? 1 : !props.isActive && props.isHovering ? 0.5 : 0,
  };

  const iconStyle: React.CSSProperties = {
    fontSize: "14px",
    verticalAlign: "middle",
    marginBottom: "3px",
  };

  return (
    <Body isHovering={props.isHovering} style={style}>
      <SpacerControls>
        <SpacerButton
          onClick={() => {
            props.services.notebookClient.logAnalyticsEvent(
              "editor-frame-clicked-add-code-cell"
            );
            insertCell("code");
          }}
          title="Add a code cell"
        >
          <Icon icon="add" size="inline" style={iconStyle} /> Code
        </SpacerButton>
        <SpacerButton
          onClick={() => {
            props.services.notebookClient.logAnalyticsEvent(
              "editor-frame-clicked-add-markdown-cell"
            );
            insertCell("markdown");
          }}
          title="Add a markdown text cell"
        >
          <Icon icon="add" size="inline" style={iconStyle} /> Markdown
        </SpacerButton>
      </SpacerControls>
    </Body>
  );
});
